import { useState } from 'react';
import { useParams } from 'react-router';
import { useSelector } from 'react-redux';
import EditFormPage from 'modules/ui/editform/EditFormPage';
import EditFormSelectField from 'modules/ui/editform/fields/EditFormSelectField';
import EditFormTextField from 'modules/ui/editform/fields/EditFormTextField';
import EditFormGroupFields from 'modules/ui/editform/subForm/EditFormGroupFields';
import EditFormSeparatorField from 'modules/ui/editform/fields/EditFormSeparatorField';
import EditFormSubComponent from 'modules/ui/editform/subForm/EditFormSubComponent';
import EditFormCheckboxField from 'modules/ui/editform/fields/EditFormCheckboxField';
import { InputAdornment } from '@material-ui/core';
import EditFormTimeField from 'modules/ui/editform/fields/EditFormTimeField';
import EditFormGridComponent from 'modules/ui/editform/subForm/EditFormGridComponent';
import DeviceEditService from '../service/DeviceEditService';
import DeviceStreaming from '../component/DeviceStreaming';
import DeviceTechnical from '../component/DeviceTechnical';
import EditFormUptimeField from '../component/EditFormUptimeField';
import DeviceIsOnline from '../component/DeviceIsOnline';

const config = data => {
	const blockClassName = 'rounded-8 border px-16 pt-10 pb-4 mb-16';
	const blockTitleClassName = 'py-8';

	return {
		key: 'deviceEditForm',
		text: 'Device',
		textKey: 'device',
		topic: 'device',
		editableAccess: data.formData.editableAccess,
		editableFields: data.formData.editableFields,
		service: DeviceEditService,
		tabList: [
			{
				key: 'info',
				text: 'Info',
				textKey: 'info'
			},
			{
				key: 'sensor',
				text: 'Sensor Configs',
				textKey: 'sensor',
			}
			/*{
				key: 'sampling',
				text: 'Sampling',
				textKey: 'sampling'
			},*/
			/*{
				key: 'scheduling',
				text: 'Scheduling',
				textKey: 'scheduling'
			},*/
			// {
			// 	key: 'streaming',
			// 	text: 'Streaming',
			// 	textKey: 'streaming'
			// }
		],
		fields: [
			/*
			{
				key: 'smartGroup',
				component: EditFormGroupFields,
				className: blockClassName,
				fields: [
					{
						key: 'sepSmart',
						text: 'Smart',
						textKey: 'sepSmart',
						component: EditFormSeparatorField,
						className: blockTitleClassName,
						isControlledInput: false
					},
					// {
					// 	key: 'classificationAlgorithmStatus',
					// 	text: 'Actual output of the classification algorithm',
					// 	textKey: 'classificationAlgorithmStatus',
					// 	component: EditFormSelectField,
					// 	type: 'enum',
					// 	items: data.formData.enumMap.classificationAlgorithmStatus
					// },
					{
						key: 'project',
						text: 'Project',
						textKey: 'Project',
						component: EditFormSelectField,
							items: data.formData.entityMap.project,
							visibleIf: () => data.user.isSuperAdmin,
							required: true
					}
				]
			},
			*/
			{
				key: 'administrativeGroup',
				component: EditFormGroupFields,
				className: blockClassName,
				fields: [
					{
						key: 'sepAdministrative',
						text: 'Administrative',
						textKey: 'sepAdministrative',
						component: EditFormSeparatorField,
						className: blockTitleClassName,
						isControlledInput: false
					},
					{
						key: 'externalName',
						text: 'Name',
						textKey: 'externalName',
						component: EditFormTextField,
						required: true
					},
					{
						key: 'project',
						text: 'Project',
						textKey: 'project',
						component: EditFormSelectField,
						items: data.formData.entityMap.project
					},
					// {
					// 	key: 'externalId',
					// 	text: 'ID',
					// 	textKey: 'externalId',
					// 	component: EditFormTextField,
					// 	type: 'number',
					// 	required: true
					// },
					// {
					// 	key: 'infrastructureElement',
					// 	text: 'Infrastructure Element',
					// 	textKey: 'infrastructureElement',
					// 	component: EditFormSelectField,
					// 	items: data.formData.entityMap.infrastructureElement
					// },
					// {
					// 	key: 'location',
					// 	text: 'Location',
					// 	textKey: 'location',
					// 	component: EditFormSelectField,
					// 	items: data.formData.entityMap.location
					// },
					{
						key: 'status',
						text: 'Status',
						textKey: 'status',
						component: EditFormSelectField,
						items: data.formData.enumMap.status
					},
					{
						key: 'deviceType',
						text: 'Device Type',
						textKey: 'deviceType',
						component: EditFormSelectField,
						items: data.formData.entityMap.deviceType
					},
				]
			},
			// {
			// 	key: 'modelGroup',
			// 	component: EditFormGroupFields,
			// 	className: blockClassName,
			// 	fields: [
			// 		{
			// 			key: 'sepModel',
			// 			text: 'Model',
			// 			textKey: 'sepModel',
			// 			component: EditFormSeparatorField,
			// 			className: blockTitleClassName,
			// 			isControlledInput: false
			// 		},
			// 		{
			// 			key: 'deviceType',
			// 			text: 'Device Type',
			// 			textKey: 'deviceType',
			// 			component: EditFormSelectField,
			// 			items: data.formData.entityMap.deviceType
			// 		},
			// 		{
			// 			key: 'sensorType',
			// 			text: 'Sensor Type',
			// 			textKey: 'sensorType',
			// 			component: EditFormSelectField,
			// 			items: data.formData.entityMap.sensorType
			// 		}
			// 	]
			// },
			{
				key: 'technicalGroup',
				component: EditFormGroupFields,
				className: blockClassName,
				fields: [
					{
						key: 'sepTechnical',
						text: 'Technical',
						textKey: 'sepTechnical',
						component: EditFormSeparatorField,
						className: blockTitleClassName,
						isControlledInput: false
					},
					/*{
						key: 'model',
						text: 'Model',
						textKey: 'model',
						component: EditFormTextField
					},*/
					/*{
						key: 'version',
						text: 'Version',
						textKey: 'version',
						component: EditFormTextField
					},*/
					{
						key: 'MAC',
						text: 'MAC',
						textKey: 'MAC',
						component: EditFormTextField
					},
					{
						key: 'IP',
						text: 'Ip',
						textKey: 'IP',
						component: EditFormTextField
					},
					{
						key: 'uptime',
						text: 'Uptime',
						textKey: 'uptime',
						component: EditFormUptimeField
					}
				]
			},
			{
				key: 'connectionGroup',
				component: EditFormGroupFields,
				className: blockClassName,
				fields: [
					{
						key: 'sepConnection',
						text: 'Connection',
						textKey: 'sepConnection',
						component: EditFormSeparatorField,
						className: blockTitleClassName,
						isControlledInput: false
					},
					{
						key: 'lastSeen',
						text: 'Last seen',
						textKey: 'lastSeen',
						component: EditFormTimeField
					}
				]
			},
			{
				key: 'sensorConfigs',
				tab: 'sensor',
				component: EditFormGridComponent,
				defaultValue: {
					id: null,
					name: null,
					period: null,
					minPeriod: null,
					maxPeriod: null,
				},
				fields: [
					{
						key: 'name',
						text: 'Name',
						component: EditFormTextField,
						required: true
					},
					{
						key: 'period',
						text: 'Period',
						component: EditFormTextField,
						type: 'number',
						required: true,
						unitConversion: 'msToSecond',
					},
					{
						key: 'minPeriod',
						text: 'Minimum Period',
						component: EditFormTextField,
						type: 'number',
						required: true,
						unitConversion: 'msToSecond',
					},
					{
						key: 'maxPeriod',
						text: 'Maximum Period',
						component: EditFormTextField,
						type: 'number',
						required: true,
						unitConversion: 'msToSecond',
					},
				]
			},
			/*{
				key: 'activeSensorList',
				text: 'Active sensors',
				textKey: 'activeSensorList',
				tab: 'sampling',
				component: EditFormSelectField,
				multiple: true,
				items: data.formData.entityMap.sensorType
			},*/
			/*{
				key: 'schedulingList',
				text: 'Scheduling',
				textKey: 'schedulingList',
				tab: 'scheduling',
				component: EditFormSubComponent,
				watchTitleKey: 'name',
				defaultValue: {
					id: null,
					name: null,
					active: true,
					schedStartTime: null,
					schedMonitorTimeInSec: null,
					schedSleepTimeInSec: null,
					schedStopTime: null
				},
				fields: [
					{
						key: 'active',
						text: 'Active',
						textKey: 'active',
						component: EditFormCheckboxField
					},
					{
						key: 'schedGroup',
						component: EditFormGroupFields,
						className: 'w-full flex flex-col sm:flex-row',
						fields: [
							{
								key: 'startTime',
								text: 'Start Time',
								textKey: 'startTime',
								className: 'sm:mr-6',
								component: EditFormTimeField
							},
							{
								key: 'monitorTimeInSec',
								text: 'Monitor time in seconds',
								textKey: 'monitorTimeInSec',
								className: 'sm:mr-6 sm:ml-6',
								component: EditFormTextField,
								type: 'number'
							},
							{
								key: 'sleepTimeInSec',
								text: 'Sleep time in seconds',
								textKey: 'sleepTimeInSec',
								className: 'sm:mr-6 sm:ml-6',
								component: EditFormTextField,
								type: 'number'
							},
							{
								key: 'stopTime',
								text: 'Stop Time',
								textKey: 'stopTime',
								component: EditFormTimeField
							}
						]
					}
				]
			},*/
			{
				key: 'deviceStreaming',
				component: DeviceStreaming,
				isControlledInput: false,
				tab: 'streaming',
				id: data.id
			}
		]
	};
};

function DeviceEditForm() {
	const user = useSelector(({ auth }) => auth.user);
	const [formData, setFormData] = useState(null);
	const { id } = useParams();

	if (formData == null) {
		DeviceEditService.getFormDataById(id).then(result => setFormData(result));
		return <></>;
	}
	const myConfig = config({ formData, id, user });
	return <EditFormPage config={myConfig} />;
}

export default DeviceEditForm;
